module.exports = __webpack_public_path__ + "static/media/courtyardflowers.4e5b240e.jpeg";